// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38tPw","list":"styles_list__1P4hz","disableSelection":"styles_disableSelection__nPtz5"};